var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.isProgressButtonCta
        ? _c("progress-button-cta", {
            attrs: {
              "button-label": _vm.progressButtonCta.buttonLabel,
              "desktop-button-label": _vm.progressButtonCta.desktopButtonLabel,
              "action-http-method": _vm.progressButtonCta.actionHttpMethod,
              "action-url": _vm.progressButtonCta.actionUrl,
              "action-form-params": _vm.progressButtonCta.actionFormParams,
              "action-json-form-params":
                _vm.progressButtonCta.actionJsonFormParams,
              "data-timer": _vm.progressButtonCta.dataTimer,
              "tms-dto": _vm.progressButtonCta.tmsDto,
              "redirect-url-on-action-functional-errors":
                _vm.progressButtonCta.redirectUrlOnActionFunctionalErrors,
              "redirect-url-on-action-technical-errors":
                _vm.progressButtonCta.redirectUrlOnActionTechnicalErrors,
              "css-classes": _vm.cssClasses,
              "aria-label": _vm.ariaLabel,
            },
          })
        : _c("simple-button-cta", {
            attrs: {
              "tms-data": _vm.simpleButtonCta.tmsDto,
              "action-url": _vm.simpleButtonCta.actionUrl,
              "action-form-params": _vm.simpleButtonCta.actionFormParams,
              "button-label": _vm.simpleButtonCta.buttonLabel,
              "desktop-button-label": _vm.simpleButtonCta.desktopButtonLabel,
              "css-classes": _vm.cssClasses,
              "aria-label": _vm.ariaLabel,
              "is-modal-opener": _vm.simpleButtonCta.modalOpener,
            },
          }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }